import React, { useEffect } from "react";
import { Line } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import { getNewClientChart } from "redux/actions/dashboardAction";
import { getChartDataset } from "helpers/utilFunctions";
import { RootState } from "types";

export default function NewClientsLineChart() {
  const expectedChart = useSelector(
    (state: RootState) => state.dashboardReducer
  );
  const chart = expectedChart?.newClientData?.data;
  // console.log(chart);
  const dispatch = useDispatch();
  const xTag = localStorage.getItem("x_jwt");
  useEffect(() => {
    dispatch(getNewClientChart(xTag, 2));
  }, [dispatch, xTag]);
  const chartLabels = chart?.labels;
  const dataLabel = chart?.datasets?.[0]?.label;
  const datasets = chart?.datasets;

  let data = {
    // x-axis labels
    labels: [
      chartLabels?.[0],
      chartLabels?.[1],
      chartLabels?.[2],
      chartLabels?.[3],
      chartLabels?.[4],
      chartLabels?.[5],
      chartLabels?.[6],
      chartLabels?.[7],
      chartLabels?.[8],
      chartLabels?.[9],
      chartLabels?.[10],
      chartLabels?.[11],
    ],
    // y-axis datasets
    datasets: [
      {
        label: dataLabel,
        data: getChartDataset(datasets, "Client Created", "totalClient"),
        backgroundColor: "#060088",
        hoverOffset: 3,
      },
    ],
  };
  let options = {
    maintainAspectRatio: false,

    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          padding: 20,
          font: {
            size: 14,
            weight: "bold",
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 2,
          font: {
            weight: "bold",
          },
        },
        labels: {
          font: {
            size: 18,
          },
        },
      },
      x: {
        beginAtZero: true,
        grid: {
          display: false,
        },
        ticks: {
          font: {
            weight: "bold",
          },
        },
      },
    },
  };
  return <Line data={data} width={400} height={100} options={options} />;
}
